export default "__VITE_ASSET__DPZGAJHh__"